<template>
    <div class="container">
        <div class="content has-text-centered">
            <h2 class="title is-4 has-text-black">What makes buying from Unet a good choice for you?</h2>
            <h1 class="subtitle is-6 text-black">Why UNET?</h1>
        </div>
        <div class="timeline" :class="{'is-centered' : !isMobile() }">
            <div class="timeline-item is-primary">
                <div class="timeline-marker is-primary is-icon">
                    <i class="fas fa-book"></i>
                </div>
                <div class="timeline-content">
                    <div class="box">
                        <p class="heading has-text-black"><strong>HUGE CATALOGUE</strong></p>
                        <p>Unet has access to more than 140 car auction houses all over Japan. Weekly, over 100,000 used cars are auctioned in the country. Therefore, the number of available used vehicles for our customers to choose from is huge.</p>
                    </div>
                </div>
            </div>
            <div class="timeline-item is-primary">
                <div class="timeline-marker is-primary is-icon">
                    <i class="fas fa-star"></i>
                </div>
                <div class="timeline-content">
                    <div class="box">
                        <p class="heading has-text-black"><strong>QUALITY</strong></p>
                        <p>Japanese used vehicles and used machinery are well known for its quality and low mileage. Japanese owners tend to do not use their vehicles very often as public transportation is great and cheap, and maintain them very well. </p>
                    </div>
                </div>
            </div>
            <div class="timeline-item is-primary">
                <div class="timeline-marker is-primary is-icon">
                    <i class="fas fa-concierge-bell"></i>
                </div>
                <div class="timeline-content">
                    <div class="box">
                        <p class="heading has-text-black"><strong>CUSTOMER SERVICE</strong></p>
                        <p>Here is where we stand over our competitors. Our team members are on the same page when it comes to this matter. We understand the difficulty of buying online a car at the Japanese auto auctions for our customers overseas.  For that reason, we focus on providing our buyers' as much information as possible to make the best decisions. Once a car is purchased at the car auctions in Japan, Unet takes care of all the processes in order to get the purchased car exported to the appointed port of destination.</p>
                    </div>
                </div>
            </div>
            <div class="timeline-item is-primary">
                <div class="timeline-marker is-primary is-icon">
                    <i class="fas fa-hand-holding-usd"></i>
                </div>
                <div class="timeline-content">
                    <div class="box">
                        <p class="heading has-text-black"><strong>AFFORDABLE USED CARS</strong></p>
                        <p>You can find at the Japanese car auctions a wide range of used vehicles and used machinery. There is a great selection of cheap used Japanese cars every day.</p>
                    </div>
                </div>
            </div>
            <div class="timeline-item is-primary">
                <div class="timeline-marker is-primary is-icon">
                    <i class="fas fa-certificate"></i>
                </div>
                <div class="timeline-content">
                    <div class="box">
                        <p class="heading has-text-black"><strong>OTHER SERVICES</strong></p>
                        <p>Unet can help you to buy half-cuts, spare parts, auto parts. This service is only available for container shipments.</p>
                    </div>
                </div>
            </div>
            <div class="timeline-item is-primary">
                <div class="timeline-marker is-primary is-icon">
                    <i class="fas fa-car"></i>
                </div>
                <div class="timeline-content">
                    <div class="box">
                        <p class="heading has-text-black"><strong>BRANDS</strong></p>
                        <p>At the car auctions in Japan, you can find any pre-owned vehicle you like. Toyota used cars, Nissan used cars, Honda used cars, Mitsubishi Used Cars, Matsuda Used cars, Subaru used cars etc. Foreign brands are also available. Mercedes used vehicles, BMM used vehicles, Audi used vehicles, Porsche used vehicles etc. For the foreign brands, you can either find LHD or RHD cars.</p>
                    </div>
                </div>
            </div>
            <div class="timeline-item is-primary">
                <div class="timeline-marker is-primary is-icon">
                    <i class="fas fa-cogs"></i>
                </div>
                <div class="timeline-content">
                    <div class="box">
                        <p class="heading has-text-black"><strong>OUR SYSTEM</strong</p>
                        <p>Unet has developed a great system that allows our customers to have full access to all the cars going on auction in Japan. In addition, all the information regarding your transactions with Unet is available at one place: purchased cars, shipping status, export documents, invoices, payments made, tools (car manufacture checker, cars catalog to see specs, inland transportation calculator), Unet´s Terms and Conditions, etc.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
          return {
              windowWidth: 0
          }
        },
        mounted () {
            this.$nextTick(function() {
                window.addEventListener('resize', this.getWindowWidth);
                this.getWindowWidth()
            })
        },
        methods: {
            getWindowWidth(event) {
                this.windowWidth = document.documentElement.clientWidth;
            },
            isMobile() {
                return this.windowWidth < 800;
            }
        }
    }
</script>

<style scoped>
    @import '../../assets/css/home.css';
    @import '../../../node_modules/bulma-extensions/bulma-timeline/dist/css/bulma-timeline.min.css';
    @media (min-width: 1024px) {
        .long {
            width: 400px;
        }
    }
    .box {
        width: 100%;
    }
    .timeline-content {
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/Home/WhyUnet.vue